import React, { useState, useEffect, useRef } from 'react';

import { formatNumber, getInputValue, formatNumericValue, parseInputValue } from '../utils';

const CommercialSection = ({ value = 0, totalCost = 0, onChange, isEditable = true, onFieldChange }) => {
	const [commercial, setCommercial] = useState(value);
	const isInitialMount = useRef(true);
	const prevValueRef = useRef(null);

	useEffect(() => {
		if (prevValueRef.current === value) {
			return;
		}

		if (value !== '' && value !== null && value !== undefined) {
			setCommercial(formatNumericValue(value));
		} else {
			setCommercial(value);
		}

		prevValueRef.current = value;
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, [value]);

	const notifyChange = (updatedCommercial) => {
		if (onChange && !isInitialMount.current) {
			onChange(formatNumericValue(updatedCommercial));
		}
	};

	const handleInputChange = (e) => {
		const value = e.target.value;
		const updatedCommercial = parseInputValue(value);
		if (onFieldChange) onFieldChange('commercialCostPercentage');
		setCommercial(updatedCommercial);
		notifyChange(updatedCommercial);
	};

	const displayCost = totalCost || 0;

	return (
		<div className="single-table trims-content border mt-5">
			<div className="table-heading d-flex align-items-center justify-content-between">
				<p>Commercial Cost Metrics</p>
			</div>
			<div className="row align-items-center py-2 border-bottom border-top m-0">
				<div className="col-md-2 pr-0">
					<p className="regular-12 gray_dark_02 pb-1">Commercial Charge (%)</p>
				</div>
				<div className="col-md-10">
					<input
						type="number"
						step="0.01"
						value={getInputValue(commercial)}
						onChange={handleInputChange}
						readOnly={!isEditable}
					/>
				</div>
			</div>
			<div className="row align-items-center m-0 total-row">
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01">Total Commercial Cost</p>
				</div>
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01 float-right">${formatNumber(displayCost)}</p>
				</div>
			</div>
		</div>
	);
};

export default CommercialSection;
